module.exports = __webpack_public_path__ + "static/media/surprise.e492f0df.svg";